module.exports = __webpack_public_path__ + "static/assets/929f57ac9661e3bad3506d6e2c3511ce.svg";